import React from 'react'
import "./ConnectWallet.scss";


function ConnectWallet({ setDelegateDialog }: { setDelegateDialog: (value: boolean) => void }) {
  return (
    <div className="connect-wallet-container">
      <div className="claim-section">
        <h2>Claim Your Tokens</h2>
        <p>View your tokens below, and start the claim process</p>
        <div className="token-box">
          <p>You will receive</p>
          <h1>20 <span className="token-symbol">$HOUSE</span></h1>
        </div>
        <p className="token-info">You have earned these tokens for being an early participant of the Lighthouse community</p>
        <div className="button-row">
          <button className="fillBtn__blue" style={{margin:'0px' , flex:1}} onClick={()=>{setDelegateDialog(true)}}>CLAIM TOKEN</button>
          <button className="fillBtn__blue" style={{background:'#4F4F4F'}}>Token Breakdown</button>
        </div>
      </div>
      <div className="account-section">
        <h3>Connected Accounts</h3>
        <div className="account-list">
          <div className="account-box">0x29b1d…..740e5E4</div>
          <div className="account-box">0x29b1d…..740e5E4</div>
        </div>
        <button className="fillBtn__blue" style={{width:'100%', margin:'0px'}}>Connect Account</button>
      </div>
    </div>
  );
}

export default ConnectWallet